
// export const myMutation = ( state ) => {

// }

export const setContracts = ( state, contracts ) => {
    state.contracts = contracts
}

export const activeContract = ( state, contract ) => {
    state.contracts.filter(c => c.id == contract.id)[0].estado = 'Activo'
}

export const deactivateContract = ( state, contract ) => {
    state.contracts.filter(c => c.id == contract.id)[0].estado = 'Inactivo'
}

export const setTypeContracts = ( state, typeContracts ) => {
    state.typeContracts = typeContracts
}

export const setPeriods = ( state, periods ) => {
    state.periods = periods
}

export const addHfsUser = ( state, hfsUserForm ) => {
    state.contracts.filter(c => c.id == hfsUserForm.contrato_id)[0]
    .periodos.filter(ca => ca.id == hfsUserForm.periodo_id)[0]
    .hfs.filter(h => h.tHfsId == hfsUserForm.hfs_id)[0].horasSemana = Number(hfsUserForm.horasTotales)

    let horasTotales = 0
    state.contracts.filter(c => c.id == hfsUserForm.contrato_id)[0]
    .periodos.filter(ca => ca.id == hfsUserForm.periodo_id)[0]
    .hfs.forEach(h => {
        horasTotales = (Number(h.horasSemana) == 0 ? 0 : Number(h.horasSemana)) + horasTotales
    })

    state.contracts.filter(c => c.id == hfsUserForm.contrato_id)[0]
    .periodos.filter(ca => ca.id == hfsUserForm.periodo_id)[0]
    .horasTotales = horasTotales
}